import React, { useState } from "react";
import DialogComponent from "../components/DialogComponent";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import axios from "axios";

function MediaAnalysis({ setDailog, roomId }) {
  const [InviteNumber] = useState(roomId);
  const [mediaAnalysisUrl, setmediaAnalysisUrl] = useState("");
  const [, setData] = useState("No Data");
  const updatedUrl = localStorage.getItem("apiEndpoint");
  const baseURL = updatedUrl?.length ? updatedUrl : window.config.apiEndpoint;

  const handleMediaAnalysisUrl = (e) => {
    setmediaAnalysisUrl(e.target.value);
  };

  function ClearResponse() {
    setData("");
  }

  function MediaAnalysisAPI(event) {
    ClearResponse();
    const headers = {
      "Content-Type": "application/json",
      apikey: localStorage.getItem("apikey") || window.config.apikey,
    };
    const acId = localStorage.getItem("accountId") || window.config?.accountId;
    const roomId = InviteNumber;
    const requestBody = {
      //       FlowData: `<?xml version="1.0" encoding="UTF-8"?>
      // <Response><Play>${flowUrl}</Play></Response>`,
      FlowData: `${mediaAnalysisUrl}`,
    };
    axios
      .post(`${baseURL}/accounts/${acId}/room/${roomId}/media-analysis`, requestBody, {
        headers: headers,
      })
      .then(function (response) {
        console.log(response);
        toast.success("Api call success");
      })
      .catch(function (error) {
        console.log(error);
        toast.error("Failed, StatusCode:" + error?.response?.data?.message);
      });
    setDailog(false);
  }

  return (
    <>
      <DialogComponent
        heading="Media Analysis"
        ButtonName="Submit"
        handleClick={MediaAnalysisAPI}
        // handleChange={handleInviteChange}
        handleChange1={handleMediaAnalysisUrl}
        PlaceholderName2="Media Analysis flow data"
        data={InviteNumber}
        data1={mediaAnalysisUrl}
        PlaceholderName="Room ID"
        setDailog={setDailog}
      />
    </>
  );
}
MediaAnalysis.propTypes = {
  setDailog: PropTypes.any,
  roomId: PropTypes.any,
};
export default MediaAnalysis;
